import MultiSelector from "../../../../../../components/Selectors/MultiSelector";
import { useEffect, useMemo, useState } from "react";
import { getWorkflows } from "../../../../../../api/WorkflowAPI";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { parseDate } from "../../../../../../functions/dates";
import { excludeProspectFromWorkflow } from "../../../../../../api/PRMAPI";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { notifications } from "@mantine/notifications";
import { Stack, Text } from "@mantine/core";

function getOptionName(option) {
  return `${option.name} #${option.id}`;
}

function getExcluded(current) {
  let result = current?.excluded_workflows || [];
  current.programmations.forEach((p) => {
    if (p.excluded_workflow) {
      result.push(p.workflow_id);
    }
  });

  return result;
}

const ExcludeWorkflow = ({ current }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const lists = useFlowStore((s) => s.workflows);
  const handleLoad = () => {
    setLoading(true);
    getWorkflows().finally(() => setLoading(false));
  };

  const options = useMemo(() => {
    return lists.map((list) => ({
      ...list,
      option_name: getOptionName(list),
    }));
  }, [lists]);

  const [values, setValues] = useState(getExcluded(current));
  const [checking, setChecking] = useState(false);
  const onChange = (v) => {
    setChecking(true);
    excludeProspectFromWorkflow({
      contact_id: current.id,
      workflow_id: v[v.length - 1]?.id,
    })
      .then((response) => {
        notifications.show({
          message: lang.prm.exclude.success_workflow,
          color: "tertiary.8",
        });
        setValues(v.map((x) => x.id));
      })
      .finally(() => setChecking(false));
  };

  useEffect(() => {
    handleLoad();
  }, []);

  return (
    <Stack gap={0}>
      <Text fw={600}>Scénario</Text>
      <Text c={"dimmed"} size="sm" mb={"xs"}>
        Exclure le prospect d'un de vos modèles de scénarios
      </Text>
      <MultiSelector
        options={options}
        label={null}
        onDropdownOpen={handleLoad}
        loading={loading}
        values={
          values
            ?.map((listId) => {
              let list = lists?.find((x) => x.id === listId);
              if (list) {
                return {
                  ...list,
                  option_name: getOptionName(list),
                };
              }
              return;
            })
            ?.filter(Boolean) || []
        }
        onChange={onChange}
        placeholder={"Scénarios"}
        rightOptionSection={(item) => {
          return (
            <>
              {item?.created_on && (
                <span style={{ fontSize: 10, opacity: 0.35, width: 105 }}>
                  {parseDate(item?.created_on)}
                </span>
              )}
              {item?.id && (
                <span style={{ fontSize: 10, opacity: 0.35 }}>#{item?.id}</span>
              )}
            </>
          );
        }}
        size={"sm"}
        w={"100%"}
        searchable
        checkIconPosition="left"
        dropdownHeight={110}
        styles={{
          input: {
            borderColor: "var(--mantine-primary-color-4)",
            borderWidth: 2,
            minHeight: 102,
          },
        }}
        autoFocus={false}
        checkboxColor="red"
        disabled={checking}
      />
    </Stack>
  );
};

export default ExcludeWorkflow;
